// Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { login, logout } from './auth';

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    // Satt av ProtectedRoute (navigate-state) eller apiAuth.js (?reason=,
    // ved hard redirect etter en 401) når brukeren havner her fordi økten
    // utløp - ikke ved et helt nytt, uinnlogget besøk.
    const øktUtløpt =
        location.state?.reason === 'expired' ||
        new URLSearchParams(location.search).get('reason') === 'expired';

    // Rydder bort det utløpte tokenet her (stabilt sluttpunkt) i stedet for i
    // ProtectedRoute, som sender oss hit - se kommentaren der.
    useEffect(() => {
        if (øktUtløpt) logout();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Vent på svaret fra backend
        const success = await login(username, password);

        if (success) {
            if (username === 'Slemmestad') {
                Cookies.set('selectedStore', 'Sport1 Slemmestad', { expires: 7 });
                Cookies.set('butikkid', '2', { expires: 7 });
            } else if (username === 'Røyken') {
                Cookies.set('selectedStore', 'Sport1 Røyken', { expires: 7 });
                Cookies.set('butikkid', '1', { expires: 7 });
            }

            // Send custom event after setting cookies
            window.dispatchEvent(new Event('storeUpdated'));

            const from = location.state?.from;
            // ?from= settes når en utløpt innlogging sender brukeren hit (se apiAuth.js).
            // Kun interne stier: må starte med én '/', og ingen backslash (åpen-redirect-triks).
            const fromQuery = new URLSearchParams(location.search).get('from');
            const redirectTo = from
                ? `${from.pathname}${from.search || ''}`
                : (/^\/(?![/\\])[^\\]*$/.test(fromQuery || '') ? fromQuery : '/');
            navigate(redirectTo, { replace: true });
        } else {
            setError('Feil brukernavn eller passord');
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
                <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">Logg inn</h2>
                {øktUtløpt && (
                    <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-4">
                        Du ble logget ut fordi økten din utløp. Logg inn på nytt for å fortsette.
                    </p>
                )}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-gray-700">Brukernavn:</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                        />
                    </div>
                    <div>
                        <label className="block text-gray-700">Passord:</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200"
                    >
                        Logg inn
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;
